import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {Loading, Message} from 'element-ui';

import axio from "./aja";
Vue.use(Vuex,axios)

let loadingInstance;
let baseUrl = 'https://www.bywhjt.com';
export default new Vuex.Store({
    state: {
        activeIndex:'0',
        BaseUrl:'https://www.bywhjt.com/',
        companys:[{
            id:10001,
            name:'博雅文化产业集团有限公司'
        },{
            id:10002,
            name:'河南博之雅印务有限公司'
        }],


        hmenu:[],//菜单


    },
    mutations: {

        activeIndex:function(that,data){
            that.activeIndex = data
        },
        homemenu:function(that,data){
            that.hmenu = data
        },

    },
    actions: {

        //前端-----------------------------------------------------
        homeindex: function (that, data) {
            return axio(baseUrl + '/index', data)
        },
        party_list: function (that, data) {
            return axio(baseUrl + '/party_list', data)
        },
        //集团结构
        group: function (that, data) {
            return axio(baseUrl + '/group', data)
        },
        //管理团队
        team: function (that, data) {
            return axio(baseUrl + '/team', data)
        },
        team_detail: function (that, data) {
            return axio(baseUrl + '/team_detail', data)
        },
        //新闻中心
        web_news_list: function (that, data) {
            return axio(baseUrl + '/web_news_list', data)
        },
        web_news_detail: function (that, data) {
            return axio(baseUrl + '/web_news_detail', data)
        },

        //加入我们
        join_us: function (that, data) {
            return axio(baseUrl + '/join_us', data)
        },
        web_creativity_list: function (that, data) {
            return axio(baseUrl + '/web_creativity_list', data)
        },
        web_creativity_detail: function (that, data) {
            return axio(baseUrl + '/web_creativity_detail', data)
        },


        //修改密码
        account_detail: function (that, data) {
            return axio(baseUrl + '/account_detail', data)
        },
        changePwd: function (that, data) {
            return axio(baseUrl + '/changePwd', data)
        },


        //菜单
        maphmenu:function (_this, data) {
            let that = _this;
            this.commit('homemenu', data);
        },

        //登录
        login_aja: function (_this, data) {
            let that = _this;
            axios({
                url: baseUrl + '/login',
                method: 'POST',
                data: data
            }).then(function (d) {
                if (d.data.code == 200) {
                    let token = d.data.token
                    sessionStorage.setItem("ACCESS_TOKRN", token);
                    that.dispatch('auth_me')
                } else {
                    Message.error(d.data.msg)
                }
            })
        },

        //前端-----------------------------------------------------
        getMenu:function(that,data){
            return axio( baseUrl +'/getMenu',data)
        },
        login:function(that,data){
            return axio( baseUrl +'/login',data)
        },
        //轮播图列表
        banner_list:function(that,data){
            return axio( baseUrl +'/banner_list',data)
        },
        banner_detail:function(that,data){
            return axio( baseUrl +'/banner_detail',data)
        },
        //轮播图删除
        banner_del:function(that,data){
            return axio(baseUrl +'/banner_del',data)
        },
        //轮播图上传
        banner_add:function(that,data){
            return axio( baseUrl +'/banner_add',data)
        },
        //上传
        upload:function(that,data){
            return axio(baseUrl +'/upload',data)
        },
        //部门列表
        department_list:function(that,data){
            return axio(baseUrl +'/department_list',data)
        },

        //新闻中心
        news_list:function(that,data){
            return axio( baseUrl +'/news_list',data)
        },
        news_detail:function(that,data){
            return axio( baseUrl +'/news_detail',data)
        },
        news_del:function(that,data){
            return axio( baseUrl +'/news_del',data)
        },
        news_status:function(that,data){
            return axio( baseUrl +'/news_status',data)
        },
        news_add:function(that,data){
            return axio( baseUrl +'/news_add',data)
        },

        //博雅作品-责任与信任
        work_list:function(that,data){
            return axio( baseUrl +'/work_list',data)
        },
        work_detail:function(that,data){
            return axio( baseUrl +'/work_detail',data)
        },
        work_del:function(that,data){
            return axio( baseUrl +'/work_del',data)
        },
        work_status:function(that,data){
            return axio( baseUrl +'/work_status',data)
        },
        work_add:function(that,data){
            return axio( baseUrl +'/work_add',data)
        },

        //加入我们
        job_list:function(that,data){
            return axio( baseUrl +'/job_list',data)
        },
        job_detail:function(that,data){
            return axio( baseUrl +'/job_detail',data)
        },
        job_del:function(that,data){
            return axio( baseUrl +'/job_del',data)
        },
        job_status:function(that,data){
            return axio( baseUrl +'/job_status',data)
        },
        job_add:function(that,data){
            return axio( baseUrl +'/job_add',data)
        },

        //党建活动/管理活动
        company_list:function(that,data){
            return axio( baseUrl +'/company_list',data)
        },
        company_detail:function(that,data){
            return axio( baseUrl +'/company_detail',data)
        },
        company_del:function(that,data){
            return axio( baseUrl +'/company_del',data)
        },
        company_add:function(that,data){
            return axio( baseUrl +'/company_add',data)
        },

        //创意中心
        creativity_list:function(that,data){
            return axio( baseUrl +'/creativity_list',data)
        },
        creativity_detail:function(that,data){
            return axio( baseUrl +'/creativity_detail',data)
        },
        creativity_del:function(that,data){
            return axio( baseUrl +'/creativity_del',data)
        },
        creativity_add:function(that,data){
            return axio( baseUrl +'/creativity_add',data)
        },

        //权限管理
        addAccount:function(that,data){
            return axio( baseUrl +'/addAccount',data)
        },
        role_add:function(that,data){
            return axio( baseUrl +'/role_add',data)
        },


    },
    modules: {
    }
})














